module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rack-on-plan",
    style: (_vm.style),
    attrs: {
      "title": _vm.title
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
        return _vm.dblclick.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.mousedown.apply(null, arguments)
      },
      "contextmenu": function($event) {
        $event.preventDefault();
        return _vm.contextmenu.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "fulfillment",
    style: (_vm.fulfillmentStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5c420ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/RackOnPlan.vue
// module id = 253
// module chunks = 1